var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',[_vm._m(0)]):_vm._e(),(!_vm.loading && !_vm.error)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('h1',[_vm._v("Ha habido un error cargando la página")])])
}]

export { render, staticRenderFns }